/** @jsxImportSource @emotion/react */
import { createStyles } from '@quickbit/qb-design-system';
import { Outlet } from 'react-router-dom';
import { inIFrame } from 'utils';
import { OnrampProvider } from './context';
import { IframeButton } from './IframeButton';

export { Preview as OnrampSendPreview } from './Preview';
export { Processing as OnrampSendProcessing } from './Processing';
export { Buy as OnrampBuy } from './Buy';
export { CashierBuy as OnrampCashierBuy } from './Buy/CashierBuy';
export { FrontBuy as OnrampFrontBuy } from './Buy/FrontBuy';
export {
  OnboardingLayout as OnrampOnboardingLayout,
  Steps as OnrampOnboardingSteps,
} from './Onboarding';
export { Login as OnrampLogin } from './Login';
export { EmailLogin as OnrampEmailLogin } from './EmailLogin';
export { Failure as OnrampFailure } from './Failure';
export { Success as OnrampSuccess } from './Success';
export { Cancelled as OnrampCancelled } from './Cancelled';
export { Completed as OnrampCompleted } from './Completed';

export const OnrampOutlet = () => {
  const styles = useStyles();

  const isIframe = inIFrame();
  return (
    <OnrampProvider>
      <div css={styles.container}>
        <div css={styles.content}>
          {isIframe && <IframeButton />}
          {!isIframe && <Outlet />}
        </div>
      </div>
    </OnrampProvider>
  );
};

const useStyles = createStyles(({ breakpoints, sizing }) => ({
  container: {
    height: '100%',
    width: '100%',
    [breakpoints.laptopSmall]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  content: {
    position: 'relative',
    width: '100%',
    height: '100%',
    [breakpoints.laptopSmall]: {
      height: 'unset',
      width: sizing.medium,
    },
  },
}));
